import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./multiselect.scss";
import { IconCheckSquare, IconChevronDown, IconSquare } from "../icons";

const MultiSelect = (props) => {
  const { selected = ["All"], onOptionSelected = () => {}, options, showAll, displayFullName = true } = props;

  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (selectedOptions.length === 0) {
      setSelectedOptions(selected);
    }
  }, [selected]);

  const toggleOption = (option) => {
    let newSelected;
    if (option === "All") {
      newSelected = ["All"];
    } else {
      if (selectedOptions.indexOf(option) >= 0) {
        newSelected = selectedOptions.filter((item) => item !== option);
      } else {
        newSelected = [...selectedOptions, option];
      }
      if (newSelected.length > 0 && newSelected.indexOf("All") >= 0) {
        newSelected = newSelected.filter((item) => item !== "All");
      }
      if (newSelected.length === 0) {
        newSelected = ["All"];
      }
    }
    onOptionSelected(newSelected);
    setSelectedOptions(newSelected);
  };

  const getName = (id) => {
    const option = options.filter((item) => item.id === id);
    if (option.length > 0) {
      return option[0].name;
    }
    return id;
  };

  const optionSelection = (selectedOptions) => {
    if (!displayFullName) {
      if (selectedOptions.length > 1) {
        return selectedOptions[0] + "+";
      } else {
        return selectedOptions[0] || "";
      }
    }
    if (selectedOptions.length > 1) {
      return getName(selectedOptions[0]) + "+";
    } else {
      return getName(selectedOptions[0]) || "";
    }
  };
  const innerHtml = (
    <div className="multi-range">
      <div className="multi-range-label">{optionSelection(selectedOptions)}</div>
      <IconChevronDown className="mpng-select-chevron" />
    </div>
  );

  return (
    <div
      style={props.style ? { ...props.style } : null}
      className={`${props.className || ""} mpng-multi-selector`}
      data-testid={props.testid || "mpng-multi-selector"}
    >
      <Dropdown tabIndex={0} className="float-right">
        <Dropdown.Toggle
          variant=""
          className="multi-selector-button"
          aria-label="Select the timezone"
          data-testid="multi-selector-trigger"
        >
          {innerHtml}
        </Dropdown.Toggle>
        <Dropdown.Menu role="listbox" className="listbox">
          {options.map((item) => {
            const checked =
              selectedOptions.indexOf(item.id) >= 0 || selectedOptions.indexOf(item.name) > 0 ? true : false;
            return (
              <Dropdown.Item className={checked ? "active" : ""} key={item.id} eventKey={item.id}>
                <span
                  role="checkbox"
                  data-testid={`multi-selector-option-${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleOption(item.id);
                  }}
                >
                  {checked ? <IconCheckSquare /> : <IconSquare />} {item.name}
                </span>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MultiSelect;
